import { useCallback, useState } from 'react'

import { Box, Grid, IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AddCircle from '@material-ui/icons/AddCircle'

import LibraryCreator from './LibraryCreator'
import LibraryList from './LibraryList'

const useStyles = makeStyles(() => ({
  box: {
    marginBottom: '1rem',
  },
}))

const LibraryManager: React.FC = () => {
  const classes = useStyles()
  const [creatingNewTemplateLibrary, setCreatingNewTemplateLibrary] = useState(false)
  const toggleCreatingNewLibrary = useCallback(() => {
    setCreatingNewTemplateLibrary((prev) => !prev)
  }, [setCreatingNewTemplateLibrary])
  return (
    <Box>
      <Box className={classes.box}>
        <Grid container alignItems='center' spacing={2}>
          <Grid item>
            <Typography variant='h5'>Template Libraries</Typography>
          </Grid>
          <Grid>
            <IconButton
              disabled={creatingNewTemplateLibrary}
              color='primary'
              size='small'
              onClick={toggleCreatingNewLibrary}
            >
              <AddCircle />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <LibraryList />
      {creatingNewTemplateLibrary && (
        <LibraryCreator toggleCreatingNewLibrary={toggleCreatingNewLibrary} />
      )}
    </Box>
  )
}

export default LibraryManager
